export default {
  middleware_url: "https://wipbut.livraisons.pro",
  cake_url: "https://wipbut.cake.livraisons.pro",
  pwa_url: "https://wipbut.app.livraisons.pro/",
  isWavesoftEnabled: false,
  isUrbantzEnabled: false,
  useMapPage: true,
  instancePrefix: "21",
  googleMap: {
    api: "AIzaSyCPQ-mWkw-QJAiIsfx23XnY-5-uWhw3vsE",
  },
};
